import React from 'react'
import eventDateRangeFormatter, {
  EventForTimeFormatter,
  formatTimezone
} from 'shared/components/event-formatted-time/eventDateRangeFormatter'
import { Trans } from '@lingui/macro'

import { Flex } from '@chakra-ui/react'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'

import { isIE } from 'shared/helpers'
const EventDateRangeFromApi = React.lazy(
  () => import('front-end/src/pages/manage-events/EventDateRangeFromApi')
)

/**
 * similar to EventFormattedTime but this one is only used on FE
 */
export const EventFormattedTimeTwoLine = (props: {
  event: EventForTimeFormatter
  timezone?: string | null
}) => {
  let date: JSX.Element | null | undefined | string
  const { event, timezone } = props

  if (isIE) {
    date = <EventDateRangeFromApi {...props} />
  } else {
    date = eventDateRangeFormatter(event, timezone ?? undefined)

    if (!date)
      return (
        <span>
          <Trans>Not Set</Trans>
        </span>
      )
  }

  return (
    <>
      <Flex direction="column" lineHeight={fontSizes['2xl']}>
        <div className="event-date range">{date} </div>
        {timezone && (
          <div className="event-date timezone">{formatTimezone(timezone)}</div>
        )}
      </Flex>
    </>
  )
}
